class DisableHoverOnScroll {
  constructor() {
    this.body = document.body;
    this.timer;

    window.addEventListener('scroll', this.disableScroll.bind(this));
  }

  disableScroll() {
    if (!window.addEventListener || !this.body.classList) {
      return;
    }
    this.timer;

    clearTimeout(this.timer);

    if (!this.body.classList.contains('disable-hover')) {
      this.body.classList.add('disable-hover');
    }
    this.timer = setTimeout(function() {
      document.body.classList.remove('disable-hover');
    }, 250);
  }
}

export default DisableHoverOnScroll;
